import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppType } from './types';

interface StepperDetails {
  activeStep: number;
  backAction: boolean;
  appType: AppType | null;
  updatedImage: boolean;
  editAction: boolean;
  appVerified: boolean;
  selectedProviders: any[];
}

const initialState: StepperDetails = {
  activeStep: 0,
  backAction: false,
  appType: null,
  editAction: false,
  appVerified: false,
  updatedImage: false,
  selectedProviders: [],
};

const appStepperDetailsSlice = createSlice({
  name: 'appStepperDetails',
  initialState,
  reducers: {
    updateAppActiveStep(state, action: PayloadAction<number>) {
      state.activeStep = action.payload;
    },
    updateAppType(state, action: PayloadAction<AppType>) {
      state.appType = action.payload;
    },
    updateBackAction(state, action: PayloadAction<boolean>) {
      state.backAction = action.payload;
    },
    updateAppEditAction(state, action: PayloadAction<boolean>) {
      state.editAction = action.payload;
    },
    updateAppVerified(state, action: PayloadAction<boolean>) {
      state.appVerified = action.payload;
    },
    updateSelectedProviders(state, action: PayloadAction<any[]>) {
      state.selectedProviders = action.payload;
    },
    updateUpdatedImage(state, action: PayloadAction<boolean>) {
      state.updatedImage = action.payload;
    },
    resetAppStepperDetails() {
      return { ...initialState };
    },
  },
});

export const {
  updateAppActiveStep,
  updateAppType,
  updateBackAction,
  updateAppEditAction,
  updateAppVerified,
  updateSelectedProviders,
  resetAppStepperDetails,
  updateUpdatedImage,
} = appStepperDetailsSlice.actions;

export default appStepperDetailsSlice.reducer;
